// User action types
export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST'
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS'
export const USER_LOGIN_FAILURE = 'USER_LOGIN_FAILURE'
export const USER_LOGOUT = 'USER_LOGOUT'
export const USER_UPDATE = 'USER_UPDATE'

// Message action types
export const ADD_MESSAGE = 'ADD_MESSAGE'
export const UPDATE_MESSAGE = 'UPDATE_MESSAGE'
export const DELETE_MESSAGE = 'DELETE_MESSAGE'
export const CLEAR_MESSAGES = 'CLEAR_MESSAGES'
export const SET_MESSAGES = 'SET_MESSAGES'
export const MIGRATE_SESSION_MESSAGES = 'MIGRATE_SESSION_MESSAGES'

// Chat session action types
export const CREATE_CHAT_SESSION = 'CREATE_CHAT_SESSION'
export const UPDATE_CHAT_SESSION = 'UPDATE_CHAT_SESSION'
export const DELETE_CHAT_SESSION = 'DELETE_CHAT_SESSION'
export const SET_ACTIVE_SESSION = 'SET_ACTIVE_SESSION'
export const SET_CHAT_SESSIONS = 'SET_CHAT_SESSIONS'
export const CLEAR_CHAT_SESSIONS = 'CLEAR_CHAT_SESSIONS'

// WebSocket action types
export const WS_CONNECT = 'WS_CONNECT'
export const WS_DISCONNECT = 'WS_DISCONNECT'
export const WS_MESSAGE_RECEIVED = 'WS_MESSAGE_RECEIVED'
export const WS_STATUS_CHANGED = 'WS_STATUS_CHANGED'
export const WS_ERROR = 'WS_ERROR'

// Stream data action types
export const UPDATE_STREAM_DATA = 'UPDATE_STREAM_DATA'
export const CLEAR_STREAM_DATA = 'CLEAR_STREAM_DATA'
export const SET_LOADING = 'SET_LOADING'

// Answer/Research action types
export const FETCH_ANSWER_REQUEST = 'FETCH_ANSWER_REQUEST'
export const FETCH_ANSWER_SUCCESS = 'FETCH_ANSWER_SUCCESS'
export const FETCH_ANSWER_FAILURE = 'FETCH_ANSWER_FAILURE'
export const SAVE_ANSWER = 'SAVE_ANSWER'
export const UPDATE_ANSWER = 'UPDATE_ANSWER'